<template>
    <div class="top-table-filter-container">
        <!-- Десктопная версия -->
        <div class="green-filter d-none d-md-flex mb-2 align-items-center">
            <!-- Фильтр статусов -->
            <span v-for="(item, index) in greenFilterMenu" 
                  :key="index" 
                  class="mr-2"
                  :class="item.active ? 'green-link active' : 'green-link'" 
                  @click="changeActive(index)">
                {{ item.title }}
            </span>

            <span class="green-link" @click="showWithdrawalRequests">Заявки на вывод</span>
        </div>

        <!-- Мобильная версия -->
        <div class="d-flex d-md-none mobile-filter-container">
            <!-- Бургер-меню -->
            <button 
                class="burger-menu-btn"
                @click="toggleMobileMenu"
                :class="{ active: isMobileMenuOpen }"
            >
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>

            <!-- Выпадающее меню -->
            <div class="mobile-dropdown" :class="{ show: isMobileMenuOpen }">
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Статус</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in greenFilterMenu"
                            :key="index"
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changeActive(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        api: {type: String, required: true}, // Ссылка на API для работы с таблицей
    },
    data() {
        return {
            isMobileMenuOpen: false,
            greenFilterMenu: [
                {title: "Все", value: "", active: true},
                {title: "Ожидает одобрения", value: "pending", active: false},
                {title: "Одобрено", value: "approved", active: false},
                {title: "Отклонено", value: "rejected", active: false},
                {title: "Выполнено", value: "completed", active: false}
            ]
        };
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),
    },    
    mounted() {
        this.changeActive(this.$store.state.userLocalSettings.filterSettings.agentSettlementsTable || 0);
    },
    methods: {
        changeActive(activeIndex) {
            let additionalParameter = '';

            // Сохраняем выбор в store
            this.$store.dispatch("userLocalSettings/SET_FILTER_SETTINGS", {
                name: 'agentSettlementsTable',
                value: activeIndex
            });

            // Обновляем активный статус в фильтре
            this.greenFilterMenu.forEach((item, index) => {
                item.active = activeIndex == index;
                
                if (activeIndex == index && item.value) {
                    additionalParameter += `&status=${item.value}`;
                }
            });

            this.$emit('setFilteringApiParameter', additionalParameter);
        },

        // Методы для мобильного меню
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },

        closeMobileMenu() {
            this.isMobileMenuOpen = false;
        },

        showWithdrawalRequests() {
            this.$router.push({ path: '/agent-withdrawal-requests' });
        }
    }
};
</script> 